import { useState, useMemo } from "react";
import AppLayout from "../../../components/AppLayout/AppLayout";
import { useNavigate } from "react-router-dom";

const allSlips = [
  { sno: "01", date: "18 Jun 2025", type: "International Relocation",    leadId: "54563" },
  { sno: "02", date: "16 Jun 2025", type: "International Relocation",    leadId: "55521" },
  { sno: "03", date: "15 Jun 2025", type: "Domestic Relocation (Air)",   leadId: "51122" },
  { sno: "04", date: "14 Jun 2025", type: "Domestic Relocation (Train)", leadId: "52345" },
  { sno: "05", date: "12 Jun 2025", type: "Domestic Relocation (Road)",  leadId: "53456" },
  { sno: "06", date: "10 Jun 2025", type: "International Relocation",    leadId: "54678" },
];

const summaryStats = [
  { label: "International\nRelocation",    count: "03",      unit: "",   iconColor: "#d4537e", bgColor: "#fbeaf0", icon: "international" },
  { label: "Domestic\nRelocation (Air)",   count: "03",      unit: "",   iconColor: "#534AB7", bgColor: "#eeedfe", icon: "air"           },
  { label: "Domestic\nRelocation (Train)", count: "03",      unit: "",   iconColor: "#534AB7", bgColor: "#eeedfe", icon: "train"         },
  { label: "Domestic\nRelocation (Road)",  count: "2450",    unit: "km", iconColor: "#534AB7", bgColor: "#eeedfe", icon: "road"          },
];

const typeColor = {
  "International Relocation":    "#d4537e",
  "Domestic Relocation (Air)":   "#534AB7",
  "Domestic Relocation (Train)": "#534AB7",
  "Domestic Relocation (Road)":  "#534AB7",
};

const PER_PAGE = 3;

export default function DutySlip({ onBack, onSlipClick }) {
  const [monthFilter, setMonthFilter] = useState("June 2025");
  const [typeFilter,  setTypeFilter]  = useState("");
  const [page, setPage] = useState(1);
    const navigate = useNavigate();

  const filtered = useMemo(
    () => (typeFilter ? allSlips.filter((s) => s.type === typeFilter) : allSlips),
    [typeFilter]
  );

  const totalPages = Math.ceil(filtered.length / PER_PAGE);
  const visible    = filtered.slice((page - 1) * PER_PAGE, page * PER_PAGE);

  const handleTypeChange = (e) => { setTypeFilter(e.target.value); setPage(1); };

  const selectStyle = {
    padding: "6px 10px", border: "1px solid #d0c8f0", borderRadius: 8,
    fontSize: 12, color: "#555", background: "#fff", outline: "none", cursor: "pointer",
  };

  return (
    <AppLayout>
         <div style={{ minHeight: "100vh", background: "#f7f7f7" }}>

    

      {/* Breadcrumb */}
      <div style={{ background: "#fff", padding: "8px 14px", borderBottom: "0.5px solid #eee", display: "flex", gap: 6 }}>
        <span style={{ fontSize: 12, color: "#888" }}>Home</span>
        <span style={{ fontSize: 12, color: "#aaa" }}>›</span>
        <span style={{ fontSize: 12, color: "#888" }}>Duty Slip</span>
      </div>

      <div style={{ padding: 14 }}>

        {/* Summary Stats Grid */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 16 }}>
          {summaryStats.map((stat) => (
            <StatCard key={stat.label} stat={stat} />
          ))}
        </div>

        {/* Section Header */}
        <div style={{ background: "#534AB7", borderRadius: 8, padding: "12px 14px", marginBottom: 14 }}>
          <span style={{ color: "#fff", fontSize: 14, fontWeight: 500 }}>Duty Slip List</span>
        </div>

        {/* Filters + Pagination */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 14, gap: 8 }}>
          <div style={{ display: "flex", gap: 8 }}>
            <select value={monthFilter} onChange={(e) => setMonthFilter(e.target.value)} style={selectStyle}>
              <option>June 2025</option>
              <option>May 2025</option>
              <option>April 2025</option>
            </select>
            <select value={typeFilter} onChange={handleTypeChange} style={selectStyle}>
              <option value="">All</option>
              <option value="International Relocation">International</option>
              <option value="Domestic Relocation (Air)">Dom. Air</option>
              <option value="Domestic Relocation (Train)">Dom. Train</option>
              <option value="Domestic Relocation (Road)">Dom. Road</option>
            </select>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
            <PgBtn label="‹" onClick={() => setPage((p) => Math.max(1, p - 1))}        disabled={page === 1} />
            <span style={{ width: 26, height: 26, background: "#534AB7", color: "#fff", borderRadius: 6, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12 }}>{page}</span>
            <PgBtn label="›" onClick={() => setPage((p) => Math.min(totalPages, p + 1))} disabled={page === totalPages} />
          </div>
        </div>

        {/* Slip Cards */}
        {visible.map((slip) => (
  <SlipCard
    key={slip.sno}
    slip={slip}
    onClick={() => navigate("/duty-slip-detail", { state: { slip } })}
  />
))}

        {visible.length === 0 && (
          <p style={{ textAlign: "center", color: "#aaa", fontSize: 13, marginTop: 30 }}>
            No records found.
          </p>
        )}
      </div>
    </div>
    </AppLayout>
   
  );
}

function StatCard({ stat }) {
  const iconMap = {
    international: (c) => (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.8">
        <circle cx="12" cy="12" r="10"/><path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10A15.3 15.3 0 0 1 12 2z"/>
      </svg>
    ),
    air: (c) => (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.8">
        <path d="M21 16v-2l-8-5V3.5a1.5 1.5 0 0 0-3 0V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"/>
      </svg>
    ),
    train: (c) => (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.8">
        <rect x="4" y="3" width="16" height="13" rx="2"/>
        <path d="M8 3v13M16 3v13M4 10h16M8 19l-2 3M16 19l2 3M12 19v3"/>
      </svg>
    ),
    road: (c) => (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.8">
        <rect x="1" y="3" width="22" height="13" rx="2"/>
        <path d="M8 18h8M12 14v4"/>
        <circle cx="6" cy="9" r="1" fill={c}/>
      </svg>
    ),
  };

  const lines = stat.label.split("\n");

  return (
    <div style={{
      background: "#fff", border: "0.5px solid #e0d8f5", borderRadius: 10,
      padding: 12, display: "flex", alignItems: "center", gap: 10,
    }}>
      <div style={{
        width: 40, height: 40, borderRadius: "50%", background: stat.bgColor,
        display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
      }}>
        {iconMap[stat.icon]?.(stat.iconColor)}
      </div>
      <div>
        <div style={{ fontSize: 20, fontWeight: 500, color: "#333" }}>
          {stat.count}
          {stat.unit && <span style={{ fontSize: 11, fontWeight: 400, color: "#888" }}>{stat.unit}</span>}
        </div>
        <div style={{ fontSize: 11, color: "#888", lineHeight: 1.3 }}>
          {lines.map((l, i) => <div key={i}>{l}</div>)}
        </div>
      </div>
    </div>
  );
}

function SlipCard({ slip, onClick }) {
  return (
    <div
      onClick={onClick}
      style={{
        background: "#fff", border: "0.5px solid #e0d8f5",
        borderRadius: 10, padding: "12px 14px", marginBottom: 10, cursor: "pointer",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
        <span style={{ fontSize: 12, color: "#555" }}>S No. : <strong>{slip.sno}</strong></span>
        <span style={{ fontSize: 12, color: "#e05c8a", fontWeight: 500 }}>Date : {slip.date}</span>
      </div>
      <div style={{ background: "#f0eeff", borderRadius: 6, padding: "8px 10px", marginBottom: 8 }}>
        <span style={{ fontSize: 13, fontWeight: 500, color: typeColor[slip.type] || "#534AB7" }}>
          {slip.type}
        </span>
      </div>
      <div style={{ display: "flex", gap: 6, fontSize: 12 }}>
        <span style={{ color: "#888", width: 60 }}>Lead ID</span>
        <span style={{ color: "#333" }}>: {slip.leadId}</span>
      </div>
    </div>
  );
}

function PgBtn({ label, onClick, disabled }) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      style={{
        width: 26, height: 26, border: "1px solid #d0c8f0", borderRadius: 6,
        background: "#fff", cursor: disabled ? "not-allowed" : "pointer",
        display: "flex", alignItems: "center", justifyContent: "center",
        fontSize: 14, color: disabled ? "#ccc" : "#534AB7",
      }}
    >
      {label}
    </button>
  );
}